import React, { useState } from "react";
import { Input, Form, Col, Row, Button } from "reactstrap";
import AdminTable from "./AdminTable";
import { useModal } from "contexts/ModalProvider";
import { useToasts } from "utils/useHotToast";
import ToastNotification from "components/Toast/ToastNotification";
import check from "assets/icons/check-circle.svg";
import slash from "assets/icons/slash-circle.svg";
import { useNavigate } from "react-router-dom";

// Custom Hooks
import useTableController from "hooks/useTableController";

// API
import { useGetAdminsQuery, useAddAdminMutation } from "services/admins/api";

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

const AdminTab = () => {
  const navigate = useNavigate();
  const { modal } = useModal();
  const { addToast, removeToast } = useToasts();
  const [isValid, setIsValid] = useState(false);

  // HOOK CHANGE
  const { formik, searchInput, setSearchInput, handleTableChange } = useTableController({
    initialValues: {},
    validationSchema: SearchFilterSchema,
  });

  // API
  const { data, error, isLoading } = useGetAdminsQuery(formik.values);
  const [addAdmin, { isLoading: isAdding }] = useAddAdminMutation();

  const handleCreate = async () => {
    navigate("/admin/form");
  };

  return (
    <Form
      className="form-horizontal w-100 d-flex flex-column gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        formik.handleSubmit();
      }}
      data-testid="search-form"
    >
      <div className="admin-tab" data-testid="tab-admin">
        <div className="header">
          <h2 className="fw-semibold">แอดมินทั้งหมด</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={12} md={12} lg={10} xl={8}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1">
                    <div className="input-group-icon">
                      <i className="bx bx-search" />
                      <Input name="searchTerm" type="text" placeholder="ค้นหาราการแอดมิน" onChange={(e) => setSearchInput(e.target.value)} value={searchInput} invalid={formik.touched.searchTerm && formik.errors.searchTerm} data-testid="search-input" />
                      {formik.touched.searchTerm && formik.errors.searchTerm && (
                        <div className="error-message" data-testid="search-error">
                          {formik.errors.searchTerm}
                        </div>
                      )}
                    </div>
                  </div>
                  <Button color="success" size="xs" onClick={handleCreate} className="d-flex gap-2" data-testid="create-button">
                    <i className="bx bx-plus"></i>
                    เพิ่มแอดมินใหม่
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <AdminTable data={data} error={error} isLoading={isLoading} onTableChange={handleTableChange} />
      </div>
    </Form>
  );
};

export default AdminTab;
